import { render } from "./ApartmentNavigation.vue?vue&type=template&id=2738d49b"
import script from "./ApartmentNavigation.vue?vue&type=script&lang=js"
export * from "./ApartmentNavigation.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/staging/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__